<div [ngClass]="{ 'is-small-button': isSmallButton(), 'is-recently-selected': isRecentlySelected() }" class="course-notification-preset-picker" ngbDropdown>
    <button pButton severity="secondary" [outlined]="true" [size]="isSmallButton() ? 'small' : undefined" class="d-flex align-items-center" type="button" ngbDropdownToggle>
        <fa-icon [icon]="selectedPresetIcon()" class="course-notification-preset-picker-toggle-icon" />
        <span class="course-notification-preset-picker-text">
            <span jhiTranslate="artemisApp.courseNotification.preset.dropdown"></span>:
            <span [jhiTranslate]="selectedPresetLangKey()"></span>
        </span>
    </button>
    <div ngbDropdownMenu>
        @for (preset of availableCourseSettingPresets(); track preset) {
            <div
                class="course-notification-preset-picker-item"
                [class.is-selected]="selectedCourseSettingPreset()?.identifier === preset.identifier"
                ngbDropdownItem
                (click)="presetSelected(preset.typeId)"
            >
                <div class="course-notification-preset-picker-item-title">
                    <fa-icon [icon]="getPresetIcon(preset.identifier)" class="course-notification-preset-picker-item-icon" />
                    @if (selectedCourseSettingPreset()?.identifier === preset.identifier) {
                        <strong [jhiTranslate]="'artemisApp.courseNotification.preset.' + preset.identifier + '.title'"></strong>
                    } @else {
                        <span [jhiTranslate]="'artemisApp.courseNotification.preset.' + preset.identifier + '.title'"></span>
                    }
                </div>
                <div>
                    <span
                        class="course-notification-preset-picker-item-description"
                        [jhiTranslate]="'artemisApp.courseNotification.preset.' + preset.identifier + '.description'"
                    ></span>
                </div>
            </div>
        }

        <div class="course-notification-preset-picker-item" [class.is-selected]="selectedCourseSettingPreset() === undefined" ngbDropdownItem (click)="presetSelected(0)">
            <div class="course-notification-preset-picker-item-title">
                <fa-icon [icon]="getPresetIcon('customUserCourseNotificationSettingPreset')" class="course-notification-preset-picker-item-icon" />
                @if (selectedCourseSettingPreset() === undefined) {
                    <strong [jhiTranslate]="'artemisApp.courseNotification.preset.customUserCourseNotificationSettingPreset.title'"></strong>
                } @else {
                    <span [jhiTranslate]="'artemisApp.courseNotification.preset.customUserCourseNotificationSettingPreset.title'"></span>
                }
            </div>
            <div>
                <span
                    class="course-notification-preset-picker-item-description"
                    [jhiTranslate]="'artemisApp.courseNotification.preset.customUserCourseNotificationSettingPreset.description'"
                ></span>
            </div>
        </div>
    </div>
</div>
